import { NavigationItemsType } from '@/constants/event-app-navigation-items';
import { EventConfiguration } from '@/resources/EventConfiguration';

export function getPageName(navigationItems: NavigationItemsType, path: string) {
  return navigationItems.find((item) => path.includes(item.route))?.id;
}

export function checkIsEventPagePublic(
  navigationItems: NavigationItemsType,
  path: string,
  eventConfiguration: EventConfiguration
) {
  const pageName = getPageName(navigationItems, path);

  return pageName ? (eventConfiguration[`${pageName}PagePublic`] as boolean) : false;
}
